import axios from 'axios';
export class HttpService {
    constructor(tokenService) {
        this.tokenService = tokenService;
    }
    async get(url, config) {
        return this.request(Object.assign({ method: 'GET', url }, config));
    }
    async post(url, config) {
        return this.request(Object.assign({ method: 'POST', url }, config));
    }
    async put(url, config) {
        return this.request(Object.assign({ method: 'PUT', url }, config));
    }
    async patch(url, config) {
        return this.request(Object.assign({ method: 'PATCH', url }, config));
    }
    async delete(url, config) {
        return this.request(Object.assign({ method: 'DELETE', url }, config));
    }
    async request(config) {
        const token = this.tokenService.getToken();
        const defaultRequestInfo = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        };
        if (token && !this.tokenService.isTokenExpired()) {
            defaultRequestInfo.headers.Authorization = `Bearer ${token}`;
        }
        return axios.request(Object.assign(Object.assign(Object.assign({}, defaultRequestInfo), config), { headers: Object.assign(Object.assign({}, defaultRequestInfo.headers), config.headers) }));
    }
    onHttpErrorStatus(error, handleStatusCode) {
        if (error.response && error.response.status) {
            const statusCode = error.response.status;
            const handleStatusCodeFn = handleStatusCode[statusCode];
            if (typeof handleStatusCodeFn === 'function') {
                handleStatusCodeFn(error);
            }
        }
    }
}
//# sourceMappingURL=HttpService.js.map